export const LIST_LIMIT_REACHED_CODE = 'LIST_LIMIT_REACHED';

/**
 * Upstream rejects list creation with 403 once the owner's list quota is
 * exhausted. Our own guards (e.g. `assertOrgAccess`) also answer 403, so the
 * create routes tag the upstream case with a code the client can tell apart.
 */
export const getCreateListErrorCode = (status: unknown) =>
  status === 403 ? LIST_LIMIT_REACHED_CODE : undefined;
